import * as React from "react";
import type { SVGProps } from "react";
const SvgKlarnaOnCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#ffb3c7"
      d="M20.08 6H3.92C2.86 6 2 7.006 2 8.247v8.506C2 17.994 2.86 19 3.92 19h16.16c1.06 0 1.92-1.006 1.92-2.247V8.247C22 7.006 21.14 6 20.08 6"
    />
    <path
      fill="#0a0b09"
      fillRule="evenodd"
      d="M20.128 13.401a.476.476 0 0 0-.474.478c0 .264.212.478.474.478a.476.476 0 0 0 .473-.478.476.476 0 0 0-.473-.478m-1.56-.37c0-.361-.306-.654-.683-.654s-.684.293-.684.654.306.655.684.655c.377 0 .684-.293.684-.655m.003-1.272h.755v2.544h-.755v-.162a1.3 1.3 0 0 1-.748.233c-.735 0-1.33-.601-1.33-1.343 0-.741.595-1.342 1.33-1.342.278 0 .535.086.748.233zm-6.04.332v-.332h-.774v2.544h.775v-1.187c0-.401.43-.616.73-.616h.008v-.74c-.306 0-.588.132-.74.33m-1.926.94c0-.361-.306-.654-.684-.654s-.684.293-.684.654.306.655.684.655.684-.293.684-.655m.003-1.272h.755v2.544h-.755v-.162a1.3 1.3 0 0 1-.749.233c-.734 0-1.33-.601-1.33-1.343 0-.741.596-1.342 1.33-1.342.278 0 .535.086.749.233zm4.543-.068c-.301 0-.587.094-.777.355v-.287h-.752v2.544h.76v-1.336c0-.387.258-.577.567-.577.332 0 .523.2.523.571v1.342h.754v-1.617c0-.592-.467-.995-1.075-.995M7.43 14.303h.79v-3.677h-.79zm-3.47.002h.836v-3.68H3.96zm2.926-3.68a2.94 2.94 0 0 1-.856 2.088l1.157 1.592H6.152l-1.257-1.73.325-.245a2.12 2.12 0 0 0 .846-1.705z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgKlarnaOnCard;
